"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

exports.__esModule = true;
exports["default"] = void 0;

var _advanceWidth = _interopRequireDefault(require("../positions/advanceWidth"));
/**
 * Return run advance width
 *
 * @param  {Object}  run
 * @return {number} advance width
 */


var advanceWidth = function advanceWidth(run) {
  return (0, _advanceWidth["default"])(run.positions || []);
};

var _default = advanceWidth;
exports["default"] = _default;